import React from 'react';
interface CollapsibleProps {
  id: string;
  open: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Panel plegable con transición CSS pura (sin dependencias de animación).
 */
export function Collapsible({
  id,
  open,
  className = '',
  children
}: CollapsibleProps) {
  return <div id={id} hidden={!open} className={`overflow-hidden transition-opacity duration-200 ease-out ${open ? 'opacity-100' : 'opacity-0'} ${className}`} data-id="element-27" data-mp="2ns7uoy6hffth">
      {children}
    </div>;
}